import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActiveFilterPill } from './active-filter-pills';

/**
 * The mockup's `.activepills` row under the toolbar: one accent pill per active
 * filter question, each with its own `✕`.
 *
 * Each `✕` is named `Remove <Label>: <Value> filter`, not `Remove <Label>
 * filter`: the grants rail's `funderType` and `grantor` pills are BOTH labelled
 * `Funder` (verbatim mockup copy, which stays as it is), so a label-only name
 * gave two simultaneously-present buttons one accessible name and left a
 * screen-reader user no way to tell which funder filter they were about to drop
 * (final review, finding #10). The visible pill already reads `Label: Value`,
 * so the name simply matches what is on screen.
 */
@Component({
    standalone: false,
    selector: 'ra-active-pills',
    templateUrl: './ra-active-pills.component.html',
    styleUrl: './ra-active-pills.component.scss',
})
export class RaActivePillsComponent {
    @Input() Pills: readonly ActiveFilterPill[] = [];
    @Output() Remove = new EventEmitter<string>();
}
